export default __webpack_public_path__ + "static/media/top20.c56e9ead.svg";